<div class="text-center mt-2">
    <h1><strong>TD-CDM Privacy Policy</strong></h1>
</div>

<div class="container">
    <div class="container">
        <div class="privacy-policy image">
            <div *ngFor="let section of privacyPolicy">
                <h3 [style.color]="section.textColor"><strong>{{ section.title }}</strong></h3>
                <div [innerHTML]="section.content"></div>
            </div>
        </div>
    </div>
</div>

<div class="footer" style="margin-top: 12%;">
    <p>©2025 TD-CDM, All Rights Reserved.</p>
</div>